export default "__VITE_ASSET__CXiHn0Wt__"